// @flow
import React from 'react'
import FormButtons from 'components/FormButtons'
import styles from './styles'

type Props = {
  accountNumber: number,
  dateOfDeath: Date,
  handleUpdateDateOfDeath: Function
}

type State = {
  date: Date,
}

class DateOfDeathForm extends React.Component<Props, State> {
  props: Props

  constructor(props) {
    super(props)
    this.state = { date: '' }
  }

  componentDidMount() {
    this.setState({ date: this.props.dateOfDeath })
  }

  _wrapSubmit = () => (event) => {
    event.preventDefault()
    this.props.handleUpdateDateOfDeath(this.state.date)
  }

  _handleChange = ({ target }) => {
    this.setState({ date: target.value })
  }

  render() {
    return (
      <section>
        <h4 className={styles.section}>Set Date of Death</h4>
        <form onSubmit={this._wrapSubmit()}>
          <div className={styles.section}>
            <label className={styles.label} htmlFor="date">
              Date of Death
            </label>
            <div className={styles.formItemQuarter}>
              <input
                className={styles.input}
                id="date"
                name="date"
                onChange={this._handleChange}
                type="date"
                value={this.state.date || ''}
              />
            </div>
          </div>
          <FormButtons
            submitLabel={'Submit'}
            // disabled={!this._canSubmit()}
          />
        </form>
      </section>
    )
  }
}

export default DateOfDeathForm
